'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Navbar = require('./Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Navbar2["default"];
module.exports = exports['default'];